import {connect} from 'react-redux'
import {GlobalState} from '../state'
import {translate, Translations} from '../filters'
import React from 'react'

type Props = {
  children: string | string[]
  translations: Translations
}

function Trans({children, translations}: Props) {
  const values = typeof children === 'string' ? [children] : children
  return <>{values.map((value, index) => <span key={index}>{translate(value, translations)}</span>)}</>
}

export default connect((state: GlobalState) => ({
  translations: state.app.translations
}))(Trans)